/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Aufenthaltsgenehmigungid2Inputs */



/**

* @param {_Field_Aufenthaltsgenehmigungid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_aufenthaltsgenehmigungid2 = /** @type {((inputs?: _Field_Aufenthaltsgenehmigungid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Aufenthaltsgenehmigungid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kopie Aufenthaltserlaubnis")
});
export { _field_aufenthaltsgenehmigungid2 as "_field_aufenthaltsgenehmigungID" }